import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import ButtonToggle from '../../ButtonToggle/index'
import { getBoundActions } from '../../../actions/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import {
  AI_VIDEOGUIDE_ENABLED_GA4_EVENT,
  AI_VIDEOGUIDE_DISABLED_GA4_EVENT,
} from '../../../services/event-tracking/index'
import { usePostHogEvent } from '../../PostHog/index'

const AIVideoGuideSettings = (props) => {
  const {
    aiVideoGuideHidden,
    staticText,
    setFeatureTrackingDataPersistent,
    setAiGa4Event,
  } = props

  const trackVideoguideEnabled = usePostHogEvent('ai_videoguide_enabled')
  const trackVideoguideDisabled = usePostHogEvent('ai_videoguide_disabled')

  const onAIVideoGuideSettingsChange = () => {
    // aiVideoGuideHidden is the current state; toggling means the new state is the opposite
    const enablingGuide = aiVideoGuideHidden // currently hidden → enabling

    // Fire the correct split GA4 event based on toggle direction
    const ga4Event = enablingGuide
      ? AI_VIDEOGUIDE_ENABLED_GA4_EVENT
      : AI_VIDEOGUIDE_DISABLED_GA4_EVENT
    setAiGa4Event(ga4Event)

    // PostHog
    if (enablingGuide) {
      trackVideoguideEnabled()
    } else {
      trackVideoguideDisabled()
    }

    setFeatureTrackingDataPersistent({
      data: Map({ aiVideoGuideHidden: !aiVideoGuideHidden }),
    })
  }

  return (
    <div className="my-account-settings-V2__display-settings-controls">
      <div className="my-account-settings-V2__display-settings-text-container">
        <div className="my-account-settings-V2__display-settings-title">
          { staticText.getIn(['data', 'aiVideoGuide']) }
        </div>
        <div className="my-account-settings-V2__display-settings-text">
          {staticText.getIn(['data', 'aiVideoGuideDesc'])}
        </div>
      </div>
      <div className="my-account-settings-V2__display-settings-toggle">
        <ButtonToggle
          checked={!aiVideoGuideHidden}
          onChange={onAIVideoGuideSettingsChange}
          showLabel
          round
        />
      </div>
    </div>
  )
}

AIVideoGuideSettings.propTypes = {
  aiVideoGuideHidden: PropTypes.bool,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
  setAiGa4Event: PropTypes.func.isRequired,
}

export default compose(
  connectRedux(
    (state) => {
      return {
        aiVideoGuideHidden: state.featureTracking.getIn(['data', 'aiVideoGuideHidden'], false),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
        setAiGa4Event: actions.eventTracking.setAiGa4Event,
      }
    },
  ),
  connectStaticText({ storeKey: 'myAccountSettingsV2' }),
)(AIVideoGuideSettings)
